<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Student Ledger">
      <v-card-actions>
        <router-link :to="{ name: 'nodalView' }">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>Back</v-btn
          >
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon></v-btn
          >
        </router-link>
      </v-card-actions>
      <v-card flat class="px-2">
        <v-row>
          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2"> Select Class</label>
            <v-autocomplete
              class="my-0 py-1"
              key="id"
              v-model="selectedClassID"
              placeholder="Select class"
              menu-props="auto"
              :items="classes"
              @change="changeSections()"
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <label class="font-weight-medium body-2"> Select Section</label>
            <v-autocomplete
              key="id"
              class="my-0 py-1"
              v-model="selectedSectionID"
              menu-props="auto"
              placeholder="Select Section"
              :items="classWiseSections"
              @change="
                getStudents(
                  franchiseeID,
                  selectedClassID,
                  selectedSectionID,
                  academicYearID
                )
              "
              item-text="name"
              item-value="id"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card>
      <v-card-component>
        <v-card-text
          class="pt-0 pr-1"
          :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }"
        >
          <v-text-field
            :class="{
              'mr-0': $vuetify.breakpoint.xs,
              'mr-5': $vuetify.breakpoint.smAndUp
            }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width: 350px"
          />
        </v-card-text>
        <v-divider class="my-0" />
        <v-data-table
          sort-by
          hide-default-footer
          :items-per-page="-1"
          :headers="headers"
          :items="searchFilterArray"
          :search="search"
          item-key="index"
        >
          <template v-slot:item.actions="{ item }">
            <v-row justify="end">
              <v-col>
                <router-link
                  :to="{
                    name: 'studentLedger',
                    params: { studentAdmissionID: item.id }
                  }"
                >
                  <v-btn class="px-2 ml-1 ma-1" outlined small color="error">
                    Ledger Details
                  </v-btn>
                </router-link>

                <router-link
                  :to="{
                    name: 'studentfeePlanAsign',
                    params: { studentAdmissionID: item.id }
                  }"
                >
                  <v-btn class="px-2 ml-1 ma-1" small color="green" outlined>
                    Fee Details
                  </v-btn>
                </router-link>
                <v-btn
                  v-if="item.orderCount === 0  && assignorder"
                  class="px-2 ml-1 ma-1"
                  small
                  color="darkblue"
                  outlined
                  @click="assignOrder(item)"
                >
                  Assign Order
                </v-btn>
                <!-- <v-btn v-if="item.orderCount === 0" class="px-2 ml-1 ma-1" @click="uniformSizeHandler(item)" small color="darkblue" outlined>
                  Select Uniform Size
                </v-btn> -->
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
    <!--Select All Size Modal Start -->
    <v-dialog
      persistent
      v-model="selectAllModal"
      :active="selectAllModal"
      :on-cancel="
        () => {
          selectAllModal = false
        }
      "
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <selectSizeModal
        ref="selectSizeModalRef"
        :key="refreshUniform"
        :studentData="studentData"
        v-on:closemodal="selectAllModal = false"
      ></selectSizeModal>
    </v-dialog>
    <!--Select All Size Modal End -->
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Utils from '@/utils'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent.vue'
import selectSizeModal from '@/components/StudentUniforms/selectSizeModal'
import stores from '@/stores'

export default {
  components: { MaterialCard, VCardComponent, selectSizeModal },
  name: 'nodalLedger',
  data () {
    return {
      headers: [
        {
          text: 'Student Name',
          sortable: true,
          value: 'studentEnrollment.studentName'
        },
        {
          text: 'Enquiry Code',
          value: 'studentEnrollment.enquiry.enquiryCode',
          sortable: true
        },
        {
          text: 'Application No',
          value: 'studentEnrollment.applicationNo',
          sortable: true
        },
        {
          text: 'Enrollment Code',
          value: 'studentEnrollment.enquiry.enrollmentCode',
          sortable: true
        },
        {
          text: 'Enrollment MCB',
          value: 'studentEnrollment.enrollmentNoMCB',
          align: 'center'
        },

        { text: 'Class', value: 'studentClass.name', sortable: true },
        { text: ' Section ', value: 'studentSection.name', sortable: true },
        {
          text: 'Admission Date',
          value: 'studentEnrollment.dateOfAdmission',
          sortable: true
        },
        { text: 'Is Active', value: 'isActive', sortable: true },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      students: [],
      refreshUniform: 0,
      selectAllModal: false,
      studentData: {},
      franchiseeID: '',
      franchiseeArr: [],
      selectedClassID: '',
      selectedSectionID: '',
      classWiseSections: [],
      classes: [],
      loadingComponent: null,
      totalStudents: 0,
      academicYearID: '',
      academicYears: [],
      isWrite: false,
      isLoading: false,
      search: '',
      searchFilterArray: []
    }
  },
  created: async function () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYearList()
    if (this.franchiseeID && this.academicYearID) {
      await this.getClassList()
    }

    this.assignorder = stores.user.ACL.superAdmin ||
    stores.user.roles.some(item => item.role === 'manual_assign_order')
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    uniformSizeHandler: function (item) {
      this.studentData = item
      this.refreshUniform++
      this.selectAllModal = true
    },
    assignOrder: async function (item) {
      this.$buefy.dialog.confirm({
        message: 'Do you want to Assign Orders?',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            this.loadingComponent = this.$buefy.loading.open()
            let response = await http.post(
              `${constants.API_URL}/api/assign-orders`,
              { admissionID: item.id }
            )
            this.loadingComponent.close()
            if (response && response.data.status === 200) {
              return this.$buefy.dialog.alert({
                type: 'is-success',
                message: response.data.message,
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            } else {
              const errorMessage = response.data.message
              this.enableUniformModal = false
              console.log('error in : ', errorMessage)
              return this.$buefy.dialog.alert({
                type: 'is-danger',
                message: errorMessage,
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',
                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
          } catch (e) {
            this.loadingComponent.close()

            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            this.enableUniformModal = false
            console.log('error in : ', errorMessage)
            return this.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      })
    },

    getYearList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        this.academicYears = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.selectedClassID = ''
        this.selectedSectionID = ''
        if (this.franchiseeID) {
          await this.getClassList()
          await this.getStudents(this.franchiseeID)
        }
        this.inProgress = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let response = await http.get(
          `${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`
        )

        const data = response.data
        this.classes = data

        this.sections = data.map((obj) => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })

        await this.getFranchiseeList()
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true

        const { data } = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        this.franchiseeArr = data.rows
      } catch (e) {
        this.isLoading = false

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.isLoading = false
      }
    },
    getStudents: async function () {
      if (this.franchiseeID) {
        try {
          this.isLoading = true

          let res = await http.get(
            `${constants.API_URL}/api/student-details?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}&sectionID=${this.selectedSectionID}&classID=${this.selectedClassID}`
          )
          this.students = res.data
          let x = this.students.map((a) => {
            a.isActive = a.isActive ? 'Active' : 'Inactive'
            a.studentEnrollment.dateOfBirth = moment(
              a.studentEnrollment.dateOfBirth,
              'YYYY-MM-DD'
            ).format('YYYY-MM-DD')
            return a
          })
          this.students = x
          this.searchFilterArray = this.students
          this.searchFilterArray.map((obj) => {
            obj.studentEnrollment.dateOfAdmission = moment(
              obj.studentEnrollment.dateOfAdmission
            ).format('DD/MM/YYYY')
          })
          this.totalStudents = res.data.length
        } catch (e) {
          this.isLoading = false
          console.log('error in student api', e)
        } finally {
          this.isLoading = false
        }
      } else {
        // this.loadingComponent.close()
        this.students = []
      }
    },
    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
          await this.getStudents()
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
